import { createStyles, makeStyles } from '@material-ui/core/styles'

export const useStyles = makeStyles(() =>
  createStyles({
    tooltip: {
      backgroundColor: '#1A1C19',
      color: '#FFFFFF',
      fontSize: '12px',
      padding: '2px 8px',
      borderRadius: '5px',
      border: 'none',
      margin: '8px',
      maxWidth: 250,
      '&.leaflet-tooltip': {
        padding: '4px 8px',
        backgroundColor: '#FFFFFF',
        '&::before': {
          display: 'none',
        },
      },
    },
  }),
)
